/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbarSearchAndPinList';
import themeConfig from '@/../themeConfig.js';
import colors from '@/../themeConfig.js';

const state = {
  isSidebarActive: true,
  breakpoint: null,
  sidebarWidth: "default",
  reduceButton: themeConfig.sidebarCollapsed,
  bodyOverlay: false,
  sidebarItemsMin: false,
  theme: themeConfig.theme || 'light',
  navbarSearchAndPinList: navbarSearchAndPinList,
  appActiveUser: {
    id: '',
    name: '',
    email: '',
    img: '',
    isSuperAdmin: false,
    isDocRegAdmin: false,
    isImmoExpert: false,
    status: 'online',
    TenantName: '',
    IsMultiTenant: false,
  },
  actifClient: null,
  themePrimaryColor: colors.primary,
  starredPages: navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  token: localStorage.getItem('token') || '',
  isSignedIn: false,
  rememberMe: false,
  isSingleSignedIn: false,
  inviteId: "",
  smsCodeVal: "",
  cognitoUser: null,
  hasConjoint: false,
};

export default state;